/**
 * Internal dependencies
 */
import { useEvents } from '@/event';

const useJoinedEvents = () =>
	useEvents().events?.filter((event) => event.hasJoined) ?? [];

export default useJoinedEvents;
